// extracted by mini-css-extract-plugin
export default {"loading-container":"loader_loading-container__b8Thh","loader":"loader_loader__Bg3W2","rotation":"loader_rotation__CVT4Z","rotationBack":"loader_rotationBack__rW+C3"};